export default "__VITE_PUBLIC_ASSET__0141b112__"